<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-import-record`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M32 2l9 9.429V24h-4v-9.962l-8 .001L28.999 6H9v36h14v4H7a2 2 0 01-2-2V4a2 2 0 012-2h25zM22 27a1 1 0 011 1v2a1 1 0 01-1 1h-8a1 1 0 01-1-1v-2a1 1 0 011-1h8zm13.778 1.293l7.071 7.071a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0l-2.937-2.937v10.33a1 1 0 01-1 1h-2a1 1 0 01-1-1V35.229l-2.963 2.964a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l7.071-7.071a1 1 0 011.414 0zM28 18a1 1 0 011 1v2a1 1 0 01-1 1H14a1 1 0 01-1-1v-2a1 1 0 011-1h14z"/></svg>
</template>
<script>

export default {
  name: 'IconImportRecord',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
